/**
 * One QueryClient, and the defaults that differ from stock.
 *
 * `refetchOnWindowFocus` is off on purpose. React Query ships it on, which
 * makes every screen re-fetch when the tab regains focus — the surprise
 * refresh this team already dislikes. Data refreshes on mount, on navigation,
 * and when a mutation invalidates it, which is enough for an audit tool.
 *
 * The retry predicate encodes the distinction the auth provider used to make
 * by hand: an answered failure is final, an unanswered one is worth retrying.
 */
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../api/errors';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			staleTime: 30_000,
			retry: (count, error) => !(error instanceof ApiError) && count < 3,
			retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 5000),
		},
		mutations: { retry: false },
	},
});
